(function() {
  'use strict';
  
  function initCustomSortSelect() {
    const container = document.getElementById('customSelectSort');
    if (!container) return;
    
    const button = container.querySelector('.custom-select-sort__button');
    const label = container.querySelector('.custom-select-sort__label');
    const list = container.querySelector('.custom-select-sort__list');
    const items = container.querySelectorAll('.custom-select-sort__item');
    const nativeSelect = document.getElementById('nativeSortSelect');
    
    if (!button || !label || !list || !nativeSelect) return;
    
    let isOpen = false;
    
    function toggleDropdown(e) {
      e.stopPropagation();
      isOpen = !isOpen;
      container.classList.toggle('custom-select-sort--open', isOpen);
    }
    
    function closeDropdown() {
      isOpen = false;
      container.classList.remove('custom-select-sort--open');
    }
    

    function selectItem(item) {
      const value = item.getAttribute('data-value');
      const text = item.textContent.trim();
      
      items.forEach(i => i.setAttribute('data-selected', 'false'));
      item.setAttribute('data-selected', 'true');
      label.textContent = text;
      
      closeDropdown();
      
      const filtersForm = document.getElementById('CollectionFiltersForm');
      
      if (filtersForm) {
        const formSortSelect = filtersForm.querySelector('[data-form-sorting] select');
        
        if (formSortSelect) {
          formSortSelect.value = value;
          
          if (nativeSelect) {
            nativeSelect.value = value;
          }
          
          filtersForm.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
          console.warn('No se encontró el select de ordenamiento en el formulario');
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          window.location.href = url.toString();
        }
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        window.location.href = url.toString();
      }
    }
    
    function handleClickOutside(e) {
      if (!container.contains(e.target)) {
        closeDropdown();
      }
    }

    button.addEventListener('click', toggleDropdown);
    
    items.forEach(item => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        selectItem(item);
      });
    });
    
    document.addEventListener('click', handleClickOutside);
    
    return () => {
      button.removeEventListener('click', toggleDropdown);
      document.removeEventListener('click', handleClickOutside);
    };
  }
  
  // Initialize
  let cleanup = null;
  
  function init() {
    if (cleanup) cleanup();
    cleanup = initCustomSortSelect();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('collection:rerendered', init);
  document.addEventListener('shopify:section:load', init);
})();